import Cam from './Cam';
export default Cam;